import { render, staticRenderFns } from "./backInvoiceTitle.vue?vue&type=template&id=4c944d68&scoped=true"
import script from "./backInvoiceTitle.vue?vue&type=script&lang=js"
export * from "./backInvoiceTitle.vue?vue&type=script&lang=js"
import style0 from "./backInvoiceTitle.vue?vue&type=style&index=0&id=4c944d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c944d68",
  null
  
)

export default component.exports